module.exports = __webpack_public_path__ + "static/media/SM-LINE.a8655b88.svg";